import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { travelMemberProductDisplayName } from '../member-identity/memberIdentityPresentation';

function snowflakeId(value) {
  if (value == null || value === '') return null;
  const id = String(value);
  return /^[1-9]\d*$/.test(id) ? id : null;
}

/**
 * Depth-1 quote reference only. Never walks nested quotedPost trees.
 * When available=false, text/media are cleared (no body/media leak).
 */
export function normalizeQuotedPostReference(raw, fallbackPostId = null) {
  if (!raw && !fallbackPostId) return null;
  const postId = snowflakeId(raw?.postId) || snowflakeId(fallbackPostId);
  if (!postId) return null;
  const available = Boolean(raw?.available);
  if (!available) {
    return {
      postId,
      available: false,
      authorName: '',
      text: '',
      coverUrl: '',
    };
  }
  const author = raw?.author || {};
  return {
    postId,
    available: true,
    authorName: travelMemberProductDisplayName({
      displayName: author.displayName,
      username: author.username,
      nickname: author.nickname,
    }) || (raw?.authorMemberId != null ? `Traveler ${raw.authorMemberId}` : 'Traveler'),
    text: String(raw?.textContent || ''),
    coverUrl: resolveMemberMediaUrl(raw?.coverFileReference),
  };
}

/** Preview of a selected source post from getDetail (direct selected post only). */
export function quotePreviewFromDetail(detail) {
  const postId = snowflakeId(detail?.postId);
  if (!postId) return null;
  const author = detail?.author || {};
  return {
    postId,
    available: true,
    authorName: travelMemberProductDisplayName({
      displayName: author.displayName,
      username: author.username,
      nickname: author.nickname,
    }) || 'Traveler',
    text: String(detail?.textContent || ''),
    coverUrl: resolveMemberMediaUrl(detail?.coverFileReference),
  };
}
